import { useState } from 'react';
import type { ResponsesArtifact } from '../data/types';
import { ParticleField } from '../motion/particles/ParticleField';
import type { ParticleLayoutName } from '../motion/particles/types';
import { ChartFrame, CurvedDivider, DataLabel, ReferenceValueLegend, ReferenceValueMarker, SectionMarker } from '../viz/primitives';

export function FoundationHarness({ responses }: { responses: ResponsesArtifact }) {
  const [layout, setLayout] = useState<ParticleLayoutName>('field');
  return (
    <main className="min-h-svh bg-atc-base p-6 text-atc-ink md:p-10">
      <div className="mx-auto max-w-7xl">
        <SectionMarker titleEn="FOUNDATION LAB" titleJp="デザイン・モーション基盤" />
        <div className="mt-8 flex flex-wrap gap-3">
          {(['field', 'grid', 'bands'] as const).map((value) => (
            <button key={value} type="button" onClick={() => setLayout(value)} className={`rounded-full px-5 py-2.5 text-sm font-bold transition-transform active:scale-[.97] ${layout === value ? 'bg-atc-primary text-white' : 'bg-white text-atc-navy shadow-sm'}`}>
              {value}
            </button>
          ))}
        </div>
        <section className="relative mt-8 h-[52vh] min-h-[28rem] overflow-hidden rounded-[2.5rem] bg-white shadow-atc-card">
          <ParticleField rows={responses.rows} layout={layout} bandField="gender" />
          <div className="pointer-events-none absolute left-8 top-8 z-10"><DataLabel value="1,386" label="identity-carrying particles" /></div>
        </section>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          <ChartFrame title="参考値表示" description="判定はデータ層から受け取り、UIでは再計算しない。">
            <div className="flex items-center gap-3 text-lg font-bold">12.4%<ReferenceValueMarker cell={{ n: 18, small: true }} /></div>
            <div className="mt-5"><ReferenceValueLegend /></div>
          </ChartFrame>
          <ChartFrame title="期間限定フィールド" description="集計期間を数値のそばに表示する。">
            <DataLabel value="243" label="訪問予算の回答" period="7/26のみ・243件" />
          </ChartFrame>
        </div>
      </div>
      <CurvedDivider className="mt-16 text-atc-primary" />
    </main>
  );
}
